import SwiperComponent from "@components/SwiperComponent"
import { process } from "./data"

export const ProcessSlider =()=>{
    return(
        <div className="container">

                   <SwiperComponent process={process}  heading='Our IoT Development Process'/>
        </div>

     )
}  